import { Modal } from "antd";
import SJButton from "../SJButton";
import "./index.scss";

interface AIContentNoticeDialogProps {
  visible: boolean;
  onClose: () => void;
}

const AIContentNoticeDialog = ({
  visible,
  onClose,
}: AIContentNoticeDialogProps) => {
  const handleConfirm = () => {
    onClose();
  };

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      centered
      width={600}
      closable={false}
      footer={null}
      className="ai-content-notice-dialog"
    >
      <div className="ai-content-notice-content">
        <div className="ai-content-notice-title">人工智能生成内容标识公告</div>

        <div className="ai-content-notice-body">
          <div className="ai-content-notice-text">
            <p>
              1、用户不得利用生成式人工智能等类似新技术制作、上传、复制、传播虚假新闻信息等法律法规禁止的信息内容。同时，对于用户发布或传播利用基于生成式人工智能等类似新技术制作的非真实信息时，应当以显著方式予以标识，否则我们有权对相关内容和账户采取包括但不限于增加标识、限制、关闭账号、暂停或者终止向您提供本服务等处置措施。
            </p>
            <p>
              2、本公司已针对生成内容进行了显著标识，提示相关内容系人工智能模型概率生成，用户不得采用技术手段删除、篡改、隐匿上述标识。
            </p>
          </div>
        </div>

        <div className="ai-content-notice-footer">
          <SJButton type="primary" onClick={handleConfirm}>
            我知道了
          </SJButton>
        </div>
      </div>
    </Modal>
  );
};

export default AIContentNoticeDialog;
